"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityHandOverMeet = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const meeting_entity_1 = require("./meeting.entity");
const opportunity_entity_1 = require("./opportunity.entity");
let OpportunityHandOverMeet = class OpportunityHandOverMeet {
};
exports.OpportunityHandOverMeet = OpportunityHandOverMeet;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityHandOverMeet.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "meetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mom", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityHandOverMeet.prototype, "mom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "hand_over_meeting_type_lid",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "handOverMeetingTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "select_meeting_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityHandOverMeet.prototype, "selectMeeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityHandOverMeet.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityHandOverMeet.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityHandOverMeet.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHandOverMeet.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], OpportunityHandOverMeet.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => meeting_entity_1.Meeting, (meeting) => meeting.id),
    (0, typeorm_1.JoinColumn)({ name: "meeting_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], OpportunityHandOverMeet.prototype, "meeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], OpportunityHandOverMeet.prototype, "status", void 0);
exports.OpportunityHandOverMeet = OpportunityHandOverMeet = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_hand_over_meet" })
], OpportunityHandOverMeet);
